import { OutOfBandTransactionStatus } from "@modules/finances/boxPaymentAtCounter/entities/outOfBandTransactionType"
import { type CustomerHistoryDto, type OutOfBandCustomerHistoryDto } from "@modules/finances/gateway/customerHistoryDto"
import { TransactionStatus } from "@modules/finances/types/financesType"

export class CustomerHistoryEntity {
  transactionId: string
  name: string | null
  amount: number
  currency: string
  date: Date
  status: TransactionStatus

  private constructor(customerHistory: CustomerHistoryEntity) {
    this.transactionId = customerHistory.transactionId
    this.name = customerHistory.name
    this.amount = customerHistory.amount
    this.currency = customerHistory.currency
    this.date = customerHistory.date
    this.status = customerHistory.status
  }

  static fromDto(customerHistoryDto: CustomerHistoryDto): CustomerHistoryEntity {
    return new CustomerHistoryEntity({
      transactionId: customerHistoryDto.transactionId,
      name: customerHistoryDto.name,
      amount: customerHistoryDto.amount,
      currency: customerHistoryDto.currency,
      date: new Date(customerHistoryDto.date),
      status: customerHistoryDto.status,
    })
  }
}

export class OutOfBandCustomerHistoryEntity {
  invoiceId: string
  name: string | null
  amount: number
  currency: string
  date: Date
  status: OutOfBandTransactionStatus

  private constructor(outOfBandCustomerHistory: OutOfBandCustomerHistoryEntity) {
    this.invoiceId = outOfBandCustomerHistory.invoiceId
    this.name = outOfBandCustomerHistory.name
    this.amount = outOfBandCustomerHistory.amount
    this.currency = outOfBandCustomerHistory.currency
    this.date = outOfBandCustomerHistory.date
    this.status = outOfBandCustomerHistory.status
  }

  static fromDto(outOfBandCustomerHistoryDto: OutOfBandCustomerHistoryDto): OutOfBandCustomerHistoryEntity {
    return new OutOfBandCustomerHistoryEntity({
      invoiceId: outOfBandCustomerHistoryDto.invoiceId,
      name: outOfBandCustomerHistoryDto.name,
      amount: outOfBandCustomerHistoryDto.amount,
      currency: outOfBandCustomerHistoryDto.currency,
      date: new Date(outOfBandCustomerHistoryDto.date),
      status: outOfBandCustomerHistoryDto.status,
    })
  }
}
